import {useCallback, useRef} from "react";
import {downloadImage, getImageFromHtml} from "../utils/ScreenshotUtils";
import {isDev} from "../utils/EnvironmentUtils";

export const useScreenshot = () => {
    const screenshotRef = useRef<HTMLDivElement>(null);

    const makeScreenshot = useCallback(async (withDownloading: boolean = true) => {
        if (screenshotRef.current) {

            const isApplePlatform =
                navigator.platform.includes('iPhone') ||
                navigator.platform.includes('iPad') ||
                navigator.platform.includes('Mac');

            if (isApplePlatform) {
                await getImageFromHtml(screenshotRef.current);
            }

            const screenshot = await getImageFromHtml(screenshotRef.current);

            if (isDev() && withDownloading) {
                downloadImage(screenshot);
            }

            return screenshot;
        }
    }, []);

    return {
        screenshotRef,
        makeScreenshot,
    }
};
